import { render, staticRenderFns } from "./turnup.vue?vue&type=template&id=abe2145c&scoped=true&"
import script from "./turnup.vue?vue&type=script&lang=js&"
export * from "./turnup.vue?vue&type=script&lang=js&"
import style0 from "./turnup.vue?vue&type=style&index=0&id=abe2145c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe2145c",
  null
  
)

export default component.exports